import styled, { css } from 'styled-components';
import { layout } from 'src/components/base';
import { Badge } from '@prisjakt/ui/badge';
import { ViewSize } from '../../types';

const WIDTH_FOR_TOOLTIP_BASE = 210;

interface IStyledOurChoiceBadgeWrapper {
  $viewSize: ViewSize;
}

export const StyledOurChoiceBadgeWrapper = styled.div<IStyledOurChoiceBadgeWrapper>`
  height: 10px;
  width: ${WIDTH_FOR_TOOLTIP_BASE}px;
  position: relative;
  top: -${layout.measurements.spacing100};
  cursor: pointer;

  ${props =>
    props.$viewSize !== undefined &&
    props.$viewSize >= ViewSize.MEDIUM &&
    css`
      top: -${layout.measurements.spacing050};
    `}
`;

export const StyledOurChoiceBadge = styled(Badge)`
  position: relative;
  left: -${layout.measurements.spacing200};
`;
